import { legacy_createStore, applyMiddleware, compose } from "redux";
// import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducer";
import thunk from "redux-thunk";

// import { persistReducer } from "redux-persist";
// import storage from "redux-persist/lib/storage";

// import { createBrowserHistory } from "history";
import api from "../Middleware/api";
// export const history = createBrowserHistory();

// const persistConfig = {
//     key: 'root',
//     storage,
// }

// const persistConfig = {
//   key: "userInfo",
//   storage: storage,
//   whitelist: ["userInfo"],
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer(history));
const composeEnhancers =
  window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;

export default function configureStore(initialState) {
  return legacy_createStore(
    // persistedReducer,
    rootReducer(history),
    initialState,
    composeEnhancers(applyMiddleware(thunk, api))
  );
}
